// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EyCxD","clinicsSelect":"styles_clinicsSelect__7L6VM"};